export default "__VITE_ASSET__B4_9Kyyp__"